import React from "react";
import { Control } from "react-hook-form";

import Box from "@mui/material/Box";
import FormControlLabel from "@mui/material/FormControlLabel";
import InputLabel from "@mui/material/InputLabel";
import Stack from "@mui/material/Stack";

import ModalForm from "components/modal-form";
import SelectFormField from "components/select-form-field";
import { COMMUNICATION_METHOD_TYPES } from "constants/patients";
import type { Patient, PatientInput } from "services/types/patients.type";

import CheckboxFormField from "../checkbox-form-field";

interface UpdatePatientPreferredCommunicationMethodModalProps {
  patient: Patient;
  isOpen: boolean;
  onCancel: () => void;
  isSubmitting: boolean;
  onSubmit: () => void;
  control: Control<PatientInput, any>;
}

const UpdatePatientPreferredCommunicationMethodModal: React.FC<
  UpdatePatientPreferredCommunicationMethodModalProps
> = ({ patient, isOpen, onCancel, isSubmitting, control, onSubmit }) => {
  return (
    <ModalForm
      isOpen={isOpen}
      isSubmitting={isSubmitting}
      onCancel={onCancel}
      onSubmit={onSubmit}
      title={`Update ${patient.fullName}'s Preferred Communication method`}
      hideBackdrop={false}
      control={control}
      maxWidth="sm"
      dialogContentSx={{ padding: 3 }}
    >
      <Stack gap={2}>
        <SelectFormField
          name="preferred_communication_method"
          label="Preferred Communication method"
          control={control}
          options={COMMUNICATION_METHOD_TYPES.getOptions()}
          required
        />

        <Box display="flex" alignItems="center" gap={1.5}>
          <InputLabel sx={{ padding: 0 }}>Do not Contact:</InputLabel>

          <FormControlLabel
            label="Call"
            control={
              <CheckboxFormField
                testId="do_not_call"
                name="do_not_call"
                control={control}
              />
            }
          />
          <FormControlLabel
            label="Email"
            control={
              <CheckboxFormField
                testId="do_not_email"
                name="do_not_email"
                control={control}
              />
            }
          />
          <FormControlLabel
            label="Direct Mail"
            control={
              <CheckboxFormField
                testId="do_not_mail"
                name="do_not_mail"
                control={control}
              />
            }
          />
          <FormControlLabel
            label="Message"
            control={
              <CheckboxFormField
                testId="do_not_message"
                name="do_not_message"
                control={control}
              />
            }
          />
        </Box>
      </Stack>
    </ModalForm>
  );
};

export default UpdatePatientPreferredCommunicationMethodModal;
